import {
  convertWeight,
  toWeightScaleUnitId,
  type WeightUnitCode,
} from '@wlb/shared/utils/weightUtils';

export interface ProfileWeightFields {
  start: string;
  current: string;
  goal: string;
}

const convertField = (
  value: string,
  fromUnit: WeightUnitCode,
  toUnit: WeightUnitCode,
): string => {
  const numericValue = Number(value);
  if (!value || !Number.isFinite(numericValue) || numericValue <= 0) return value;

  return convertWeight(
    numericValue,
    toWeightScaleUnitId(fromUnit),
    toWeightScaleUnitId(toUnit),
  ).toFixed(1);
};

/** Converts all profile weight fields together when the display unit changes. */
export const convertProfileWeightFields = (
  fields: ProfileWeightFields,
  fromUnit: WeightUnitCode,
  toUnit: WeightUnitCode,
): ProfileWeightFields => {
  if (fromUnit === toUnit) return fields;

  return {
    start: convertField(fields.start, fromUnit, toUnit),
    current: convertField(fields.current, fromUnit, toUnit),
    goal: convertField(fields.goal, fromUnit, toUnit),
  };
};

/** Keeps a decimal weight input numeric and limits it to one decimal point. */
export const sanitizeWeightInput = (value: string): string => {
  const numeric = value.replace(/[^0-9.]/g, '');
  const decimalIndex = numeric.indexOf('.');
  if (decimalIndex < 0) return numeric;

  return `${numeric.slice(0, decimalIndex + 1)}${numeric
    .slice(decimalIndex + 1)
    .replace(/\./g, '')}`;
};
